import { useSelector, useDispatch } from "react-redux";
import React, { useState, useEffect } from "react";
import {
    getListDanhSachDonDatHang,
    updateDataSearch,
} from "../../../actions/DanhSachDonDatHang";
import Icon from "@mdi/react";
import { mdiMagnify } from "@mdi/js";
import { getBranch, utilsOnChangeSelectTypeDate } from "utils/utils";
import arrowShow from "Resources/ImagesNew/icon_filters_.png";
import { DateTimePicker } from "react-widgets";
import moment from "moment";
import "moment/locale/vi";
import LangugeVi from "constants/vi";
import { Dropdown, DropdownButton, Table } from "react-bootstrap";
import arrowSearch from "Resources/ImagesNew/ion_chevron-back.png";

moment.locale("vi", LangugeVi.VietNamese);

export const SearchBar1 = ({
    isModalVisible,
    toggleModal,
    selected,
    setSelected,
    listTextSearch,
    setListTextSearch,
}) => {

    const dispatch = useDispatch();
    const dataSearch = useSelector((state) => state.dataSearchDanhSachDonDatHang);
    const listDonHang = useSelector((state) => state.listDanhSachDonDatHang);
    const updateState = (field, text) => {
        dispatch(
            updateDataSearch({
                ...dataSearch,
                [field]: text,
            })
        );
    };
    const list = [
        // { key: "0", value: "Tất cả" },
        { key: "1", value: "Hôm nay" },
        { key: "2", value: "Hôm qua" },
        { key: "3", value: "Tuần này" },
        { key: "4", value: "Tuần trước" },
        { key: "5", value: "Tháng này" },
        { key: "6", value: "Tháng trước" },
        { key: "7", value: "Quý này" },
        { key: "8", value: "Quý trước" },
        { key: "9", value: "Năm này" },
        { key: "10", value: "Năm trước" },
        { key: "11", value: "Tuỳ chỉnh thời gian" },
    ];
    const [showSelectThoiGian, setShowSelectThoiGian] = useState(false);

    const updateTextValue = (field) => (e) => {
        updateState(field, e.target.value);
    };


    const updateDropdown = (field) => (e) => {
        updateState(field, e.target.value);
    };

    const [dateToNew, setDateToNew] = useState(new Date());
    const [dateFromNew, setDateFromNew] = useState(new Date());
    const onChangeDate1 = (field) => (e) => {
        setDateToNew(e);
        updateState(field, moment(e).format("YYYY-MM-DD"));
    };

    const onChangeDate2 = (field) => (e) => {
        setDateFromNew(e);
        updateState(field, moment(e).format("YYYY-MM-DD"));
    };
    /*tìm kiếm thời gian ver 2*/
    const handleSelect = (key, event) => {
        setSelected({ key, value: event });
        // alert(`you chosen: ${key}`);
        if (key === "11") {
            setShowSelectThoiGian(true);
        } else {
            setShowSelectThoiGian(false);
        }

        const thongtin = { ...dataSearch };
        thongtin.typeDate = key;
        thongtin.pageIndex = 1;
        utilsOnChangeSelectTypeDate(thongtin);
        dispatch(
            updateDataSearch({
                ...thongtin,
                typeDate: key,
                pageIndex: 1,
            })
        );
    };
    const [doubleClick, setDoubleClick] = useState(false);
    const loadTaiSan = () => {
        getListDanhSachDonDatHang(dataSearch);
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }; // set lên đầu page ví dụ khi phân trang
    const onSearch = () => {
        setDoubleClick(true);
        toggleModal(false);
        dispatch(getListDanhSachDonDatHang(dataSearch));
        loadTaiSan(dataSearch);
        setDoubleClick(false);


        const obj1 = { name: dataSearch.sSearch, field: "sSearch" };
        const obj2 = { sTrangThai: dataSearch.sTrangThai, field: "sTrangThai" };
        const obj3 = {
            name: dataSearch.typeDate,
            tuNgay: dataSearch.tuNgay,
            denNgay: dataSearch.denNgay,
            field: "typeDate",
        };
        setListTextSearch({
            ...listTextSearch,
            List: [obj1, obj2, obj3],
        });


    };
    const onSearch1 = () => {
        setDoubleClick(true);
        dispatch(getListDanhSachDonDatHang());
        loadTaiSan(dataSearch);
        setDoubleClick(false);

        const obj1 = { name: dataSearch.sCode, field: "sCode" };
        const obj2 = { name: dataSearch.cusName, field: "cusName" };
        const obj3 = {
            tuNgay: dataSearch.tuNgay,
            denNgay: dataSearch.denNgay,
            field: "tuNgay",
        };
        const obj4 = { name: dataSearch.sTrangThai, field: "sTrangThai" };
        setListTextSearch({
            ...listTextSearch,
            List: [obj1, obj2, obj3, obj4],
        });
    };
    const handleKeyDown = (event) => {
        if (event.key === "Enter") {

            dispatch(
                updateDataSearch({
                    ...dataSearch,
                    iPageIndex: event,
                })
            );
            dispatch(getListDanhSachDonDatHang());
        }
    };

    const handleKeyDownEnter = (context) => (e) => {
        if (e.keyCode === 13) {
            onSearch();
        }
    };

    const handleKeyDownEnterPopUp = (context) => (e) => {
        if (e.keyCode === 13) {
            onSearch();
        }
    };
    return (
        <>
            <div className="search-ver2 search-main">
                <div className="row">
                    <div className="col-md-12">
                        <div className="main-search-input-wrap">
                            <div className="main-search-input fl-wrap">
                                <div
                                    className={
                                        isModalVisible
                                            ? "main-search-input-item main-search-input-item-active"
                                            : "main-search-input-item"
                                    }
                                >
                                    <input
                                        type="text"
                                        value={dataSearch.sCode}
                                        onChange={updateTextValue("sSearch")}
                                        placeholder="Mã đơn đặt hàng"
                                        onKeyDown={handleKeyDownEnter()}
                                    />
                                </div>
                                <div
                                    className={
                                        isModalVisible
                                            ? "main-search-button main-search-button1-active"
                                            : "main-search-button"
                                    }
                                >
                                    <div>
                                        <a
                                            href={() => false}
                                            onClick={() => toggleModal(true)}
                                            className={
                                                isModalVisible
                                                    ? "iconSearch iconSearch-active"
                                                    : "iconSearch"
                                            }
                                        >
                                            <img src={arrowShow} alt="" />
                                        </a>
                                    </div>
                                    <div className="iconSearchNew">
                                        <button
                                            className="button-left"
                                            onClick={onSearch}
                                            disabled={doubleClick}
                                        >
                                            <Icon
                                                path={mdiMagnify}
                                                title="Tìm kiếm"
                                                size={1.4}
                                                color="#9F9F9F"
                                            />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        {/* <div className="align-end marT-20">
              
            </div> */}
                    </div>
                </div>

                {isModalVisible && (
                    <div
                        className="dropdown-menu dropdown-search-nangcao"
                        id="showSearch"
                    >
                        <div className="FormSearch-show">
                            <div className="col-lg-12">
                                <div className="row">
                                    {/* <div className="col-lg-4">
                                        <div className="form-group">
                                            <label className="text-label-new">Tên khách hàng</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={dataSearch.sSearch}
                                                onChange={updateTextValue("sSearch")}
                                                onKeyDown={handleKeyDownEnterPopUp()}
                                            ></input>
                                        </div>
                                    </div> */}
                                    <div className="col-lg-4">
                                        <div className="form-group">
                                            <label className="text-label-new">Trạng thái</label>
                                            <select
                                                class="form-control selectCss"
                                                value={dataSearch.sTrangThai}
                                                onChange={updateDropdown("sTrangThai")}
                                            >
                                                <option value="-1">Tất cả</option>
                                                <option value="0">Chờ chốt</option>
                                                <option value="1">Đã chốt</option>
                                                <option value="2">Không chốt</option>
                                                <option value="3">Lên đơn 1 phần</option>
                                                <option value="4">Hoàn thành</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 select-time-ver2">
                                        <div className="form-group">
                                            <label className="text-label-new">Thời gian</label>
                                            <Dropdown
                                                show={showSelectThoiGian}
                                                onToggle={(show) => setShowSelectThoiGian(show)}
                                            >
                                                <Dropdown.Toggle
                                                    variant="success"
                                                    id="dropdown-basic"
                                                    className="input-search-time"
                                                >
                                                    {selected?.value || list[0].value}
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu variant="dark">
                                                    <Table
                                                        borderless
                                                        // variant="dark"
                                                        style={{
                                                            marginBottom: 0,
                                                            background: "#fff",
                                                            borderRadius: 0,
                                                            overflow: "hidden",
                                                            boxShadow: "0 0px 0px rgba(0,0,0,0.175)",
                                                        }}
                                                    >
                                                        <tbody>
                                                            <tr>
                                                                <td>
                                                                    <Table
                                                                        hover
                                                                        borderless
                                                                        // variant="dark"
                                                                        style={{
                                                                            marginBottom: 0,
                                                                            border: 0,
                                                                        }}
                                                                    >
                                                                        <tbody>
                                                                            {list.map((item, index) => {
                                                                                return (
                                                                                    <Dropdown.Item
                                                                                        key={index}
                                                                                        eventKey={item.key}
                                                                                        onSelect={() =>
                                                                                            handleSelect(item.key, item.value)
                                                                                        }
                                                                                        className={
                                                                                            dataSearch.typeDate === "11" &&
                                                                                                item.key === "11"
                                                                                                ? "active-search"
                                                                                                : ""
                                                                                        }
                                                                                    >
                                                                                        {item.value}
                                                                                        {item.key === "11" && (
                                                                                            <img src={arrowSearch} alt="" />
                                                                                        )}
                                                                                    </Dropdown.Item>
                                                                                );
                                                                            })}
                                                                        </tbody>
                                                                    </Table>
                                                                </td>

                                                                <td
                                                                    style={
                                                                        dataSearch.typeDate === "11"
                                                                            ? {
                                                                                borderLeftWidth: 1,
                                                                                borderLeftColor: "#02499B",
                                                                                borderLeftStyle: "solid",
                                                                            }
                                                                            : null
                                                                    }
                                                                >
                                                                    {dataSearch.typeDate === "11" && (
                                                                        <>
                                                                            <div className="col-lg-12">
                                                                                <div className="form-group checkWhite date-fix">
                                                                                    <label className="text-label-new">
                                                                                        Từ ngày
                                                                                    </label>
                                                                                    {/* <input
                                            className="form-control"
                                            type="date"
                                            value={dataSearch.tuNgay}
                                            onChange={updateTextValue("tuNgay")}
                                          /> */}
                                                                                    <DateTimePicker
                                                                                        onKeyDown={handleKeyDownEnterPopUp()}
                                                                                        format={"DD/MM/YYYY"}
                                                                                        time={false}
                                                                                        onChange={onChangeDate1("tuNgay")}
                                                                                        value={dateToNew}
                                                                                        culture="vi"
                                                                                        style={{
                                                                                            width: "185px",
                                                                                        }}
                                                                                    />
                                                                                </div>
                                                                            </div>

                                                                            <div className="col-lg-12">
                                                                                <div className="form-group checkWhite date-fix">
                                                                                    <label className="text-label-new">
                                                                                        Đến ngày
                                                                                    </label>
                                                                                    {/* <input
                                            className="form-control"
                                            type="date"
                                            value={dataSearch.denNgay}
                                            onChange={updateTextValue(
                                              "denNgay"
                                            )}
                                          /> */}
                                                                                    <DateTimePicker
                                                                                        onKeyDown={handleKeyDownEnterPopUp()}
                                                                                        format={"DD/MM/YYYY"}
                                                                                        time={false}
                                                                                        onChange={onChangeDate2("denNgay")}
                                                                                        value={dateFromNew}
                                                                                        culture="vi"
                                                                                        style={{
                                                                                            width: "185px",
                                                                                        }}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                    )}
                                                                    {dataSearch.typeDate === "11" && (
                                                                        <div class="button-search-dropdown">
                                                                            <button
                                                                                type="submit"
                                                                                class="text-dropdown-button-new"
                                                                                onClick={() => {
                                                                                    const thongtin = { ...dataSearch };
                                                                                    thongtin.typeDate = "1";
                                                                                    thongtin.iPageIndex = 1;
                                                                                    utilsOnChangeSelectTypeDate(thongtin);
                                                                                    dispatch(
                                                                                        updateDataSearch({
                                                                                            ...thongtin,
                                                                                            typeDate: "1",
                                                                                            pageIndex: 1,
                                                                                        })
                                                                                    );

                                                                                    setSelected({
                                                                                        key: "1",
                                                                                        value: "Hôm nay",
                                                                                    });

                                                                                    setShowSelectThoiGian(false);
                                                                                }}
                                                                            >
                                                                                Huỷ
                                                                            </button>
                                                                            <button
                                                                                class="text-dropdown-button"
                                                                                onClick={() =>
                                                                                    setShowSelectThoiGian(false)
                                                                                }
                                                                            >
                                                                                Áp dụng
                                                                            </button>
                                                                        </div>
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </Table>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div>
                                    </div>

                                    {/* <div className="col-lg-3">
                    <div className="form-group">
                      <label className="text-label-new">Trạng thái</label>
                      <select class="form-control">
                        <option value="1">Đã giao</option>
                        <option value="1">Chưa giao</option>
                        <option value="1">Đang giao</option>
                      </select>
                    </div>
                  </div> */}
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-12">
                            <div className="footer-search-main">
                                <button
                                    type="submit"
                                    className="text-button-search"
                                    onClick={() => toggleModal(false)}
                                >
                                    <i className="ti-search"></i>Bỏ qua
                                </button>
                                <button
                                    className="button-Add-NoIcon bg-blue-main"
                                    onClick={onSearch}
                                    disabled={doubleClick}
                                >
                                    <Icon path={mdiMagnify} title="Tìm kiếm" size={1.3} />
                                    Tìm kiếm
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};
